import { render, staticRenderFns } from "./teamTasks.vue?vue&type=template&id=a0d9ef5c"
import script from "./teamTasks.vue?vue&type=script&lang=js"
export * from "./teamTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports